import mutations from './mutations'
import * as actions from './actions'

const state = {
  states : [],
  selected_state: {},
  selected_statelaws: []
}

export default {
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/statelaws/index.js